import { useState } from 'react';
import { GridItem, Button, Box, H2 } from '@bigcommerce/big-design';
import AddressBoxes from './AddressBoxes';
import './addressList.css';
import { useClient } from '../../../context/client';

export default function AddressList({ customer, setCustomer }) {
	const [addressesLoading, setAddressesLoading] = useState(false);
	const client = useClient();

	const showLoadMoreButton =
		customer.address_count > 10 &&
		customer.address_count > customer.addresses.length;
	const getCustomerValue = (name) => customer?.[name] ?? '';
	const isAddressSelected = (id) =>
		getCustomerValue('shipping_address').id === id;

	function setCustomerInformation(name, value) {
		const customerCopy = { ...customer }; // get a copy of the current customer
		customerCopy[name] = value;
		setCustomer({ ...customerCopy });
	}

	async function handleLoadMore() {
		setAddressesLoading(true);

		try {
			const customerAddresses = await client.getCustomerAddresses(
				customer.id,
			);
			const updatedCustomerAddresses = customerAddresses.map((address) =>
				mapAddressVariables(address),
			);

			setCustomerInformation('addresses', updatedCustomerAddresses);
			setAddressesLoading(false);
		} catch (err) {
			console.error(err);
		}
	}

	// For any data names that are different when you get the address from the addresses route, change them to match the customer data addresses
	function mapAddressVariables(address) {
		// original is the name of the item you want to replace, and new is the name of the item you want to replace it with.
		const mapData = [
			{ original: 'street_1', new: 'address1' },
			{ original: 'street_2', new: 'address2' },
			{ original: 'state', new: 'state_or_province' },
			{ original: 'zip', new: 'postal_code' },
		];

		for (const item of mapData) {
			if (address[item.original])
				address[item.new] = address[item.original];
		}

		return address;
	}

	return (
		<Box padding="large">
			<H2>Addresses On File</H2>
			<Box
				className={
					customer.address_count && customer.address_count > 4
						? 'addressListContainerScroll'
						: 'addressListContainer'
				}
			>
				<AddressBoxes
					customer={customer}
					isAddressSelected={isAddressSelected}
					setCustomerInformation={setCustomerInformation}
				/>
				{showLoadMoreButton && (
					<GridItem gridColumn="1 / span 2" className="textCenter">
						<Button
							width="100%"
							onClick={handleLoadMore}
							isLoading={addressesLoading}
						>
							Load more
						</Button>
					</GridItem>
				)}
			</Box>
		</Box>
	);
}
